import * as Sentry from '@sentry/react';

/**
  * Generic error handler. This error handler can be extended to hook into error reporting tools like Sentry.
  * Unlike src/lib/js/error.js, this file is webpack/browser compatible.
  *
  * @param {string} message - The error message to report.
  * @param {object} err - The error object to report. OPTIONAL.
  * @param {object} data - A custom data object to report. OPTIONAL.
  */
export const reportError = (message?: string, err?: object, data?: object) => {
  // stringifying the errors makes them a little more difficult to read, but prevents
  // Datadog from counting each line of these errors as a separate error
  if(typeof window !== 'undefined') {
    console.error(message, JSON.stringify(err), JSON.stringify(data));
  } else {
    const { getLogger } = require('@toasttab/toast-express-common');
    getLogger().error({
      message: message,
      error: err ? JSON.stringify(err) : 'error absent',
      data: data ? data : {}
    });
  }
  Sentry.captureException(err || message);
};

export const reportErrorMessageWithData = (message: string, extra?: object) => {
  // stringifying the errors makes them a little more difficult to read, but prevents
  // Datadog from counting each line of these errors as a separate error
  if(typeof window !== 'undefined') {
    console.error(message, JSON.stringify(extra));
  } else {
    const { getLogger } = require('@toasttab/toast-express-common');
    getLogger().error({
      message: message,
      data: extra ? extra : {}
    });
  }
  Sentry.captureMessage(message, { level: 'error', extra: { ...extra } });
};
